import { render, staticRenderFns } from "./DoctorInfoTempList.vue?vue&type=template&id=8b3e8536&scoped=true&"
import script from "./DoctorInfoTempList.vue?vue&type=script&lang=js&"
export * from "./DoctorInfoTempList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorInfoTempList.vue?vue&type=style&index=0&id=8b3e8536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3e8536",
  null
  
)

export default component.exports